<template>
  <div id="immunization-tool">
    <div>
      <div class="main-content-immunization" :style="`display: ${computedMainDisplay}`">
        <!-- main header -->
        <div class="header-container">
          <svg class="calendar-svg" alt="calendar" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMinYMid meet"></svg>
          <h2 class="h2-height">{{ locale('Intro.Header') }}</h2>
        </div>
        <p class="intro-text" v-html="locale('Intro.Sentence1')" />
        <p class="intro-text" v-html="locale('Intro.Sentence2')" />
        <p class="intro-text" v-html="locale('Intro.Sentence3')" />
        <intro-inputs
          ref="introInputs"
          v-model="introValues"
          v-on:submit="onUpdateIntroValues"
          />
      </div>

      <div class="main-content-immunization" :style="`display: ${computedResultsDisplay}`">
        <!-- results header -->
        <div class="header-container">
          <svg class="calendar-svg" alt="calendar" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMinYMid meet"></svg>
          <h2 id="vue-header-results">{{ childName ? locale('Result.Header').replaceAll('Your child', childName).replace('votre enfant', childName) : locale('Result.Header') }}</h2>
        </div>
        <p class="intro-text" v-html="childName ? locale('Result.Sentence1').replaceAll('your child', childName).replace('votre enfant', childName) : locale('Result.Sentence1') " />
        <p class="intro-text" v-html="locale('Result.Sentence2')" />

        <div class="schedule-buttons">
          <a id="addScheduleLink">
            <ontario-button
              id="addSchedule"
              btn-type="secondary"
              :label="locale('Result.Calendar1')"
              v-on:click="downloadSchedule"
            />
          </a>
          <ontario-button
            id="addGoogle"
            btn-type="secondary"
            :label="locale('Result.Calendar2')"
            v-on:click="addGoogleSchedule"
          />
          <ontario-button
            id="print"
            btn-type="secondary"
            :label="locale('Result.Print')"
            v-on:click="printResults"
          />
        </div>
        <ontario-alert
          id="googleCalendarLinks"
          type="informational"
          :show-icon="false"
          :title="locale('Result.Calendar2')"
          v-show="showGoogleCalendar == true"
        />

        <ontario-alert
          type="warning"
          :title="locale('Result.Card.Title')"
          :show-icon="false"
          v-if="childAge > 1"
        >
          <p>{{ childName ? locale('Result.Card.Description1-1').replace('Your child', childName).replace('Votre enfant', childName): locale('Result.Card.Description1-1') }} {{ childAge }} {{ locale('Result.Card.Description1-2') }}</p>
        </ontario-alert>

        <!-- Results of clicking 'Get Schedule -->
        <result-accordions
          :childName="childName"
          :birthday="birthdayGiven"
          v-on:create="onUpdateSchedule"
          v-on:print="onUpdatePrint"
          :key="resultKey"
        />

        <ontario-button
          id="resetSchedule"
          btn-type="primary"
          :label="locale('Result.Reset')"
          v-on:click="resetScheduleButton"
        />
        <ontario-button
          id="getShare"
          btn-type="secondary"
          :label="locale('Result.Share.Button')"
          v-on:click="shareButton"
        />
        <p>
          <ontario-button
            v-if="showShareButton"
            v-on:click="shareFacebook"
            btn-type="secondary"
            label="Facebook"
          />
          <ontario-button
            v-if="showShareButton"
            v-on:click="shareTwitter"
            btn-type="secondary"
            label="Twitter"
          />
        </p>
      </div>

      <!-- sidebar -->
      <div class="sidebar">
        <h4>{{ locale('Sidebar.Header') }}</h4>
        <p v-html="locale('Sidebar.Body1')" />
        <p v-html="locale('Sidebar.Body2')" />
        <p v-html="locale('Sidebar.Body3')" />
      </div>
    </div>

  </div>
</template>

<script>
import drupal from '../../shared/mixins/drupal';
import IntroInputs from './components/IntroInputs.vue'
import Button from '../../shared/components/Button';
import Alert from '../../shared/components/Alert';
import ResultAccordions from './components/resultAccordions.vue';
import { downloadIcs, monthsOld } from '../src/functions/appFunctions.js';
import 'print-js';

export default {
  name: 'App',
  mixins: [drupal],
  components: {
    IntroInputs,
    OntarioButton: Button,
    OntarioAlert: Alert,
    ResultAccordions
  },
  data() {
    return {
      introValues: null,
      submitted: false,
      computedResultsDisplay: "none",
      computedMainDisplay: "block",
      birthdayGiven: '',
      childName: '',
      icsSchedule: '',
      googleSchedule: '',
      showShare: false,
      showGoogleCalendar: false,
      printData: '',
      resultKey: 0,
    }
  },
  computed: {
    childAge() {
      return Math.floor(monthsOld(this.birthdayGiven));
    },
    showShareButton() {
      this.showShare;
      return this.showShare;
    }
  },
  methods: {
    onUpdateIntroValues(data){
      this.childName = data[0];
      this.birthdayGiven = data[1];
      this.computedResultsDisplay = "block";
      this.computedMainDisplay = "none";
    },
    resetScheduleButton() {
      this.forceRerender();
      this.childName = '';
      this.birthdayGiven = '';
      this.computedResultsDisplay = "none";
      this.computedMainDisplay = "block";
      this.introValues = null;
      this.submitted = false;
      this.$refs.introInputs.resetState();
      this.showGoogleCalendar = false;
      this.showShare = false;

      // Scroll to the top of the app.
      window.scrollTo(0, window.scrollY + document.getElementById('immunization-tool').getBoundingClientRect().top - 60);
    },
    shareButton() {
      this.showShare = !this.showShare;
    },
    shareFacebook() {
      window.open(this.locale('Result.Share.Facebook'), '_blank');
    },
    shareTwitter() {
      window.open(this.locale('Result.Share.Twitter'), '_blank');
    },
    onUpdateSchedule(data){
      this.icsSchedule = data;
    },
    onUpdatePrint(data) {
      this.printData = data;
    },
    downloadSchedule() {
      downloadIcs(this.icsSchedule);
    },
    addGoogleSchedule() {
      this.showGoogleCalendar = !this.showGoogleCalendar;
    },
    // Uses printJS to create a print preview of the upcoming vaccinations needed.
    printResults() {
      var headerString = this.childName ? this.locale('Result.Header').replaceAll('Your child', this.childName).replace('votre enfant', this.childName) : this.locale('Result.Header');

      printJS({
        printable: this.printData,
        type: 'json',
        properties: [
          { field: 'date', displayName: this.locale('Print.Dates') },
          { field: 'vaccine', displayName: this.locale('Print.Vaccines') },
          { field: 'appointment', displayName: this.locale('Print.Appointment') }
        ],
        header: '<h2>' + headerString + '</h2> <h4>' + this.locale('Print.Header') + '</h4>',
        style: 'th {width: 15%; border: 1px solid black double} th:nth-child(2) {width: 70% !important;} td { padding: 4px;} tr:last-child { border: 1px solid black;}',
        gridStyle: 'border: 1px solid black double; border-style: double;',
      })
    },
    forceRerender() {
      this.resultKey +=1;
    }
  }
}

  // Add hardcoded Google analytics
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event' : 'pageview',
    'ministryTag': 'Health',
    'topic': 'Health and wellness|Vaccines and immunization',
    'contentType': 'page',
  })
</script>

<style lang="scss">
  #immunization-tool > div {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
  }
  .main-content-immunization {
    max-width: 750px;
  }
  .sidebar {
    max-width: 768px;
    flex-shrink: 2;
    flex-basis: 25%;
    flex-grow: 2;
  }
  @media only screen and (max-width: 640px) {
    .sidebar {
      max-width: unset;
      flex-basis: unset;
    }
  }
  .header-container {
    display: flex;
  }
  .inline-text {
    display: inline;
  }
  .h2-height {
    height: auto !important;
  }
  .intro-text {
    max-width: 768px;
  }
  .calendar-svg {
    background: url('../../shared/components/assets/ontario-icon-calendar.svg') no-repeat left;
    background-size: 48px 48px;
    min-width: 24px !important;
    width: 48px;
    height: 48px;
    padding: 0;
    padding-right: 40px;
    margin: 0;
    margin-right: 20px;
    margin-left: -6px;
    display: inline;
    color: #0066CC;
  }
  .schedule-buttons {
    display: flex;
  }

  @media screen and (max-width: 40em) {
    .schedule-buttons {
      display: block;
    }
  }

  .google-links {
    display: block;
  }
</style>
